module.exports = __webpack_public_path__ + "media/images/home-bg-1024-a9b57a11b2b38516428cde184781b9b4.png";